import { env } from '../lib/env';

export type Category = {
  id: string;
  name: string;
  slug: string;
  imagePath?: string | null;
  productCount?: number;
};

export async function fetchCategories(): Promise<Category[]> {
  const response = await fetch(`${env.API_URL}/api/products/categories`);

  if (!response.ok) {
    throw new Error('Failed to fetch categories');
  }

  const data = (await response.json()) as Category[];

  return Array.isArray(data) ? data : [];
}
